import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';

@Injectable({ providedIn: 'root' })
export class ExpenseService {

  url = ConfigService.toApiUrl('expenses/');

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<any>(`${this.url}`, ConfigService.addAction('list'));
  }

  summary() {
    return this.http.get<any>(`${ConfigService.toApiUrl('expenses-summary')}`, ConfigService.addAction('list'));
  }

  store(ressource: any) {
    return this.http.post<any>(`${this.url}`, ressource, ConfigService.addAction('add'));
  }

  update(id: any, ressource: any) {
    ressource['_method'] = 'patch';
    return this.http.post<any>(`${this.url}${id}`, ressource, ConfigService.addAction('edit'));
  }

  delete(id: any) {
    return this.http.delete<any>(`${this.url}${id}`, ConfigService.addAction('delete'));
  }

  setState(id: any, state: any) {
    return this.http.get<any>(`${ConfigService.toApiUrl('expenses-set-state')}/${id}/state/${state}`, ConfigService.addAction('status'));
  }
}
